import { useMemo } from "react";

export default function NewLineToBreak({
  value = ""
}: {
  value: any;
}) {
  const memoized = useMemo(() => {
    return <span dangerouslySetInnerHTML={{ __html: value.trim().replace(/\r?\n/g, "<br>") }}></span>
  }, [value]);

  return <>{memoized}</>;
}
